import { PageHeader, cn } from '@sitewise/ui';
import { useQuery } from '@tanstack/react-query';
import { NavLink, Outlet } from 'react-router-dom';

import { fetchMe } from '../../../api/auth.js';

interface TabItem {
  to: string;
  label: string;
  adminOnly?: boolean;
  end?: boolean;
}

const TABS: TabItem[] = [
  { to: '/inspections', label: 'Overview', end: true },
  { to: '/inspections/runs', label: 'Inspections' },
  { to: '/inspections/templates', label: 'Templates' },
  { to: '/inspections/schedules', label: 'Schedules', adminOnly: true },
];

export function InspectionsLayout() {
  const meQuery = useQuery({ queryKey: ['me'], queryFn: fetchMe });
  const isAdmin = meQuery.data?.user.role === 'admin';
  const visible = TABS.filter((t) => !t.adminOnly || isAdmin);

  return (
    <>
      <PageHeader
        title="Inspections"
        description="Build templates, schedule recurring inspections, and run them on a tablet — defects auto-roll into work orders."
      />
      <nav className="mb-4 border-b border-border">
        <ul className="flex gap-1 -mb-px">
          {visible.map((tab) => (
            <li key={tab.to}>
              <NavLink
                to={tab.to}
                end={tab.end ?? false}
                className={({ isActive }) =>
                  cn(
                    'inline-block border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'border-primary text-primary'
                      : 'border-transparent text-fg-secondary hover:text-fg',
                  )
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </>
  );
}
